import {openProductPopupHandler} from "./productPopup";

const quoteButtons = [...document.querySelectorAll('.js-popup-quote-trigger')];

if(quoteButtons) {
    quoteButtons.map(quoteButton => {
        quoteButton.addEventListener('click', (e) => {
            e.preventDefault();
            openProductPopupHandler('product-quote', e.srcElement.dataset.title);
        });
    });
}
